/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { UpdateStudentDataViewModel } from "../types/UpdateStudentDataViewModel.ts";

export const updateStudentDataViewModelSchema = z.object({
  ra: z.string().describe("Registro Acadêmico (RA) do aluno.").nullish(),
  codeUsp: z.string().describe("Código USP atual do aluno.").nullish(),
  codeUspOld: z.string().describe("Código USP antigo do aluno.").nullish(),
  curriculum: z
    .string()
    .describe("Grade curricular associada ao aluno.")
    .nullish(),
  perfilPublic: z
    .boolean()
    .describe("Indica se o perfil do aluno é público. Opcional.")
    .nullish(),
  isGraduateFinished: z
    .boolean()
    .describe("Indica se o aluno concluiu a graduação. Opcional.")
    .nullish(),
  graduateFinishedDate: z
    .string()
    .datetime()
    .describe("Data de conclusão da graduação do aluno. Opcional.")
    .nullish(),
}) as unknown as ToZod<UpdateStudentDataViewModel>;
